import { type ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useLanguageStore } from "@/hooks/ui/useLanguageStore";

interface LanguageInitializerProps {
	children: ReactNode;
}

export function LanguageInitializer({ children }: LanguageInitializerProps) {
	const { i18n } = useTranslation();
	const language = useLanguageStore((state) => state.language);

	useEffect(() => {
		if (i18n.language !== language) {
			void i18n.changeLanguage(language);
		}
	}, [language, i18n]);

	return <>{children}</>;
}
